// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__rbbpu","info":"Panel_info__6qP58","btns":"Panel_btns__TFv0g","button":"Panel_button__T0V0J","loading":"Panel_loading__HXAX+","loader":"Panel_loader__TuCfJ"};